export default __webpack_public_path__ + "static/media/glrc-course.cooking-method.0f24cf74.png";